var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_556)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.71875 11.0318C0.71875 8.24068 1.82753 5.56386 3.80116 3.59022C5.7748 1.61659 8.45162 0.507813 11.2428 0.507812C14.0339 0.507813 16.7107 1.61659 18.6844 3.59022C20.658 5.56386 21.7668 8.24068 21.7668 11.0318C21.7668 13.823 20.658 16.4998 18.6844 18.4734C16.7107 20.4471 14.0339 21.5558 11.2428 21.5558C8.45162 21.5558 5.7748 20.4471 3.80116 18.4734C1.82753 16.4998 0.71875 13.823 0.71875 11.0318ZM10.6422 15.5361L16.7012 7.96162L15.6067 7.08602L10.4401 13.5421L6.78058 10.493L5.88253 11.5707L10.6422 15.5361Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.048,
    height: 21.048,
    fill: "white",
    transform: "translate(0.719727 0.507812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkWhite);
export default __webpack_public_path__ + "static/media/checkmarkWhite.804ef7608cd1611f666e0a51b565101a.svg";
export { ForwardRef as ReactComponent };